import { createFileRoute } from "@tanstack/react-router";
import PiataExternaDetail from "@/pages/PiataExternaDetail";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/piata-externa/$id/")({
  head: ({ params }) => routeHead("/piata-externa/$id/", params as Record<string, string>),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PiataExternaDetail />
  );
}
